import { CountriesPhone } from '../constants/countries'
import { IPhoneInput } from '../ui/phone-input'

export const validatePhone = (phoneField?: IPhoneInput) => {
  if (!phoneField) return false

  const selectedCountry =
    CountriesPhone[phoneField?.code as keyof typeof CountriesPhone] || {}

  return phoneField?.phone?.length >= selectedCountry?.length
}
